import { mergeAttributes } from '@tiptap/core'
import Image from '@tiptap/extension-image'

export default Image.extend({
    name: 'ApkDniReverso',

    inline() {
        return true
    },

    group() {
        return 'inline'
    },

    addAttributes() {
        return {
            ...this.parent?.(),
            kind: {
                default: null,
                parseHTML: (element) => element.getAttribute('data-kind'),
                renderHTML: () => ({
                    'data-kind': this.name,
                    // style: 'width: auto;height: 50px;border-bottom: #000 2px solid;position: relative;bottom: 10px;',
                    style: 'width: auto;height: 220px',
                    class: "apk-dniReverso"
                }),
            },
        }
    },
    parseHTML() {
        return [
          {
            tag: 'img[data-type="ApkDniReverso"]'
          },
        ]
      },

    renderHTML({ HTMLAttributes }) {
        return ['img', mergeAttributes({ 'data-type': "ApkDniReverso" }, this.options.HTMLAttributes, HTMLAttributes)]
    },

    addCommands() {
        return {
          setDniReverso: options => ({ commands }) => {
            return commands.insertContent({
              type: this.name,
              attrs: options,
            })
          },
        }
    },
})